import { atom, useAtom } from 'jotai';

export const menusAtom = atom(new Map());

export const useMenus = () => {
  return useAtom(menusAtom);
};
